import React from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { MdDelete } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { setVisaCountryDeleteIndex } from "./contactSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import IconButton from "../../components/common/IconButton";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import FormDatePicker from "../../components/formFields/FormDateField";
import { ICountry } from "../country/countryModel";

const VisaCountryArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const VisaCountryDeleteIndex = useAppSelector(
    (state) => state.contact.VisaCountryDeleteIndex
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const CountryList = useAppSelector((state) => state.country.CountryList);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("visaCountryDeleteDialog"));
    dispatch(setVisaCountryDeleteIndex(index));
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setVisaCountryDeleteIndex(-1));
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        VisaExpiryDate: "",
        VisaCountryID: null,
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {!fieldArrayRenderProps.value ? pushElementInarray() : null}
      {fieldArrayRenderProps?.value &&
        fieldArrayRenderProps?.value?.length < 1 && (
          <GridLayoutItem style={{ marginTop: 20, textAlign: "end" }}>
            <Button
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={pushElementInarray}
              type="button"
            >
              Add Visa Country
            </Button>
          </GridLayoutItem>
        )}
      {dialogName === "visaCountryDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Visa Country"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(VisaCountryDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((ContactVisa: any, index: number) => (
          <GridLayoutItem key={index}>
            <GridLayout
              style={{ marginRight: 30 }}
              gap={{ rows: 0, cols: 10 }}
              cols={[
                { width: "30%" },
                { width: "30%" },
                { width: "20%" },
                { width: "20%" },
              ]}
            >
              <GridLayoutItem>
                <Field
                  name={`ContactVisa.${index}.VisaCountryID`}
                  label="Visa Country"
                  placeholder="i.e. Canada"
                  component={FormSelectionField}
                  options={CountryList?.map((country: ICountry) => {
                    return {
                      value: country?.ID,
                      label: country?.CountryName,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name={`ContactVisa.${index}.VisaExpiryDate`}
                  label="Visa Expiry Date"
                  format="dd/MM/yyyy"
                  component={FormDatePicker}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ textAlign: "center" }}>
                <IconButton
                  onClick={() => handleOpenDeleteDialog(index)}
                  disabled={fieldArrayRenderProps?.value?.length === 1}
                  themeColor={"error"}
                  size={"small"}
                  fillMode={"solid"}
                  type="button"
                  style={{
                    height: 30,
                    width: 30,
                    marginTop: 35,
                  }}
                  icon={MdDelete}
                  iconClassName="absolute-position"
                  iconStyle={{ fontSize: "24px" }}
                />
              </GridLayoutItem>
              {fieldArrayRenderProps.value?.length - 1 === index && (
                <GridLayoutItem className="text-end">
                  <Button
                    fillMode={"solid"}
                    themeColor={"primary"}
                    onClick={pushElementInarray}
                    type="button"
                    style={{ marginTop: 35 }}
                  >
                    Add Visa Country
                  </Button>
                </GridLayoutItem>
              )}
            </GridLayout>
          </GridLayoutItem>
        ))}
    </GridLayout>
  );
};

export default VisaCountryArray;
